module.exports = __webpack_public_path__ + "static/media/Value_Oriented.f8e20c70.svg";